import React from "react";
import { Warning } from "@phosphor-icons/react";
import { money, fmtDate } from "@/lib/format";
import { withdrawalPhrase } from "@/lib/withdrawalNames";

/** What the page Review now opens says about each expense holding more 529
 *  money than it cost. Figures are the server's (`details` on the
 *  overfunded_expense attention source); sentences approved by Maryse,
 *  17 Oct 2026 (ZEN-785). */
export function OverfundedExplanation({ attention, expenses = [], withdrawals = [] }) {
  const details = (attention?.sources || []).find((s) => s.key === "overfunded_expense")?.details || [];
  if (!details.length) return null;
  const byId = Object.fromEntries(withdrawals.map((w) => [w.id, w]));
  return (
    <div className="mb-3 space-y-2" data-testid="overfunded-explanation">
      {details.map((d) => {
        const e = expenses.find((x) => x.id === d.id);
        const year = d.tax_year || (e?.transaction_date || "").slice(0, 4) || null;
        const shares = d.withdrawals.map((w) => {
          const known = byId[w.withdrawal_id] || w;
          return `${money(w.amount_usd, "USD")} from ${withdrawalPhrase(known)}`;
        });
        return (
          <div key={d.id} className="flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-amber-800"
            data-testid={`overfunded-explanation-${d.id}`}>
            <Warning size={16} weight="bold" className="mt-0.5 shrink-0" aria-hidden="true" />
            <div className="text-xs leading-relaxed">
              <div className="font-semibold">More 529 money is matched to this expense than it cost</div>
              {e && <div className="text-amber-700">{[e.payee, e.transaction_date ? fmtDate(e.transaction_date) : null].filter(Boolean).join(" · ")}</div>}
              <div>
                This expense cost {money(d.cost, "USD")}. {money(d.drawn, "USD")} from 529 withdrawals is matched to it — {money(d.over, "USD")} more than it cost.
              </div>
              <div>Matched: {shares.join(" · ")}.</div>
              <div>
                To fix it, match the extra {money(d.over, "USD")} to another expense paid{year ? ` in ${year}` : " the same year"}, or return it to the 529 account.
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
